import axios from "@galaxy/modules/Core/resources/js/axiosBuilder";
import getDatabaseColors from "../../../../../Canvas/resources/components/canvas/blocks/utils/text/admin/getDatabaseColors";

common.View.create('crud::form.inputs.Richtext', {

	ckEditor: null,
	allowBlurOnce: false,
	dbColors: [],

	onDOMLoad()
	{
		this.initCkeditor();
	},

	async initCkeditor()
	{
		// Get textarea.
		let textarea = this.element.find('textarea').get(0);

		// Init Ckeditor.
		CKEDITOR.replace(textarea, await this.getOptions());
	},

	async getOptions()
	{
		let options = {

			extraPlugins: 'link,colorbutton,sourcedialog,justify,embed,autoembed,dialogadvtab',

			// Needed so CKeditor doesn't remove image advanced by default
			removeDialogTabs: '',

			embed_provider: '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}',

			colorButton_colors: await this.initDatabaseColors(),

			stylesSet: [],

			// Toolbar
			toolbarGroups: [
				{name: 'document', groups: ['mode', 'document', 'doctools', 'source', 'embed']},
				{name: 'clipboard', groups: ['clipboard', 'undo']},
				{name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing']},
				{name: 'forms', groups: ['forms']},
				{name: 'basicstyles', groups: ['basicstyles', 'cleanup']},
				{name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph']},
				{name: 'link', groups: ['links']},
				{name: 'insert', groups: ['insert']},
				{name: 'styles', groups: ['styles', 'colors']},
			],
			removeButtons: 'PasteFromWord,Paste,Copy,Replace,Find,SelectAll,Source,Scayt,Form,Checkbox,Radio,Textarea,Select,TextField,Button,HiddenField,Save,Preview,Print,NewPage,Templates,Strike,Subscript,Superscript,RemoveFormat,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,JustifyBlock,Language,BidiRtl,BidiLtr,Anchor,Flash,HorizontalRule,PageBreak,Iframe,FontSize,Font,BGColor,ShowBlocks,Maximize,About,SpecialChar',

			// TODO Enable, but will break link plugin - the button disappears.
			//allowedContent: 'ul li a[*] b strong i h2 h3 h4',
			extraAllowedContent: 'iframe[*]',

			format_tags: 'p;h2;h3;h4;h5',

			language: 'nl',

			on: {
				instanceReady: this.onCkeditorLoaded.bind(this),
			},
		};

		// Apply app options.
		options = require('@resources/js/galaxy/crud/form/inputs/richtext.js')(options);

		// Apply input specific options
		let elementOptions = this.element.find('textarea').data('ckeditorStyle');
		if (elementOptions) {
			options = require('@resources/js/galaxy/crud/form/inputs/' + elementOptions + '.js')(options);
		}

		return options;
	},

	async initDatabaseColors()
	{
		// Grab database colors
		let databaseColors = (await getDatabaseColors()).data;

		// Initialize empty array
		let colorsToCkeditor = [];

        // Add colors from database to array in CKeditor format
        $.each(databaseColors || [], function (item, value)
        {
            if (typeof value !== 'string') {
                for (let [key, val] of Object.entries(value)) {
                    colorsToCkeditor.push(key + '/' + val);
                }
            } else {
                colorsToCkeditor.push(item + '/' + value);
            }
        })

        // Filter duplicates
        let colors = _.uniq(colorsToCkeditor);

        // Replace # as CKeditor adds this
        colors = colors.map(color => color.replace('#', ''));

		// Return colors
		return [
			'white/ffffff',
			'black/000000',
			...colors,
		].join(',');
	},

	onCkeditorLoaded(event)
	{
		// Set
		this.ckEditor = event.editor;

		CKFinder.setupCKEditor(this.ckEditor);

		// Fix textarea styling
		this.copyTextareaStyling();
	},

	copyTextareaStyling()
	{
		// Find textarea
		let textarea = this.element.find('textarea');

		// Find target element
		let targetElement = this.element.find('.cke_editable');

		// Copy class from textarea to target element
		targetElement.attr('class', textarea.attr('class'))
	},

});
